import { Image, Button, Upload, UploadFile, UploadProps } from "antd";
import ImgCrop from "antd-img-crop";
import { useCallback, useState } from "react";
import ConfirmDelete from "../ConfirmDelete";
import { PopUp } from "../PopUp";
import { ErrorMessage } from "../Toasts/ErrorMessage";

type uploadProps = {
  imageUploaded?: string;
  loading: boolean;
  setUploadModal: React.Dispatch<React.SetStateAction<boolean>>;
  checklistFile: File | null;
  previewImage: {
    file: string;
    imagePreviewUrl: string | null;
  };
  setChecklistFile: React.Dispatch<React.SetStateAction<File | null>>;
  setPreviewImage: React.Dispatch<
    React.SetStateAction<{
      file: string;
      imagePreviewUrl: string | null;
    }>
  >;
  onImageDelete: () => void;
  setIsCropModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;

  uploadedImageURL?: string | undefined;
  saveUpload: () => void;
  uploadModal: boolean;
  modalPreviewImage: {
    file: string;
    imagePreviewUrl: string | null;
  };
  setModalPreviewImage: React.Dispatch<
    React.SetStateAction<{
      file: string;
      imagePreviewUrl: string | null;
    }>
  >;
  uploadBtnText?: string;
  infoTextUploader?: string;
  size?: number;
  darkBg?: boolean;
};

// type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

const UploadPhoto = (props: uploadProps) => {
  const {
    imageUploaded,
    loading,
    setUploadModal,
    checklistFile,
    previewImage,
    setChecklistFile,
    setPreviewImage,
    onImageDelete,
    setIsCropModalOpen,
    size,
    darkBg,
    uploadBtnText,
    infoTextUploader = "A photo makes it easier for colleagues to recognize you. It’s optional",
  } = props;
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const onChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  // const onPreview = async (file: UploadFile) => {
  //   let src = file.url as string;
  //   if (!src) {
  //     src = await new Promise((resolve) => {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(file.originFileObj as FileType);
  //       reader.onload = () => resolve(reader.result as string);
  //     });
  //   }
  //   const image = new HTMLImageElement();
  //   image.src = src;
  //   const imgWindow = window.open(src);
  //   imgWindow?.document.write(image.outerHTML);
  // };

  const deleteFunction = () => {
    if (onImageDelete) {
      onImageDelete();
    }
    setChecklistFile(null);
    setPreviewImage({
      file: "",
      imagePreviewUrl: null,
    });
    setConfirmDelete(false);
    setIsCropModalOpen && setIsCropModalOpen(false);
  };

  const confirmDeletePhoto = {
    visibility: confirmDelete,
    class: "upload_photo_modal",
    content: (
      <ConfirmDelete
        title=""
        onClose={() => {
          setIsCropModalOpen && setIsCropModalOpen(false);
          setConfirmDelete(false);
        }}
        heading="Delete photo"
        paragraph="Delete your profile photo?"
        btnText="Delete photo"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => {
      setIsCropModalOpen && setIsCropModalOpen(false);
      setConfirmDelete(false);
    },
  };

  const handleFileChange = useCallback(
    (file: File) => {
      setChecklistFile(file);
      const isIMG = file.type === "image/png" || file.type === "image/jpeg";
      if (!isIMG) {
        ErrorMessage(`${file.name} is not an image file`);
        // setFileTypeError(true);
      } else {
        // setFileTypeError(false);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage({
            file: file.name,
            imagePreviewUrl: reader.result as string,
          });
        };
        reader.readAsDataURL(file);
      }
      return isIMG || Upload.LIST_IGNORE;
    },
    [setChecklistFile, setPreviewImage]
  );

  console.log("previewImage", previewImage);

  return (
    <>
      <div
        className="location_photo"
        style={{
          backgroundImage: `url(${
            darkBg
              ? imageUploaded || checklistFile?.name
                ? "/images/upload/after-upload.png"
                : "/images/upload/before-upload.png"
              : ""
          })`,
        }}
      >
        <div className="location_image">
          <div className="upload_avatar">
            <ImgCrop
              // rotationSlider
              modalProps={{
                centered: true,
                closable: false,
                wrapProps: { wrapClassName: "image-crop-modal" },
              }}
              beforeCrop={() => setIsCropModalOpen && setIsCropModalOpen(true)}
              onModalCancel={() =>
                setIsCropModalOpen && setIsCropModalOpen(false)
              }
              onModalOk={() => setIsCropModalOpen && setIsCropModalOpen(false)}
              modalWidth={640}
              modalOk="Apply changes"
            >
              <Upload
                fileList={[]}
                showUploadList={false}
                onChange={onChange}
                beforeUpload={handleFileChange}
                customRequest={() => null}
                maxCount={1}
                accept="image/png, image/jpeg"
              >
                {fileList.length < 5 && (
                  <Image
                    src={
                      previewImage?.imagePreviewUrl || imageUploaded
                        ? previewImage?.imagePreviewUrl || imageUploaded
                        : darkBg
                        ? "/images/myProfile/upload-avatar-dark.svg"
                        : "/images/myProfile/upload-avatar.png"
                    }
                    width={size ?? 86}
                    height={size ?? 86}
                    alt="Profile"
                    preview={false}
                  />
                )}
                <div className="upload_btn">
                  <Button
                    onClick={() => setUploadModal(true)}
                    className={
                      darkBg
                        ? "outlined-btn-transparent btn-sm"
                        : "outlined-btn btn-sm"
                    }
                  >
                    {uploadBtnText ??
                      (imageUploaded || checklistFile?.name
                        ? "Change photo"
                        : "Upload photo")}
                  </Button>

                  {(imageUploaded || checklistFile?.name) && (
                    <Button
                      className={
                        darkBg
                          ? "outlined-btn-transparent btn-sm"
                          : "outlined-btn btn-sm"
                      }
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsCropModalOpen && setIsCropModalOpen(true);
                        setConfirmDelete(true);
                      }}
                    >
                      Delete photo
                    </Button>
                  )}
                </div>
              </Upload>
            </ImgCrop>
          </div>
          <p style={{ color: darkBg ? "#DEE5E6" : "#98A3A9" }}>
            {infoTextUploader}
          </p>
        </div>
      </div>

      <PopUp {...confirmDeletePhoto} />
    </>
  );
};

export default UploadPhoto;
